import { createFrameStats } from '../lib/frameStats';
import type { MeshFrame } from './codec';

export interface MeshReceiverOptions {
  /** Au-delà, le maillage est considéré perdu. */
  readonly staleMs?: number;
}

export interface MeshReceiver {
  /** `true` si la frame est retenue (plus récente que la précédente). */
  push(frame: MeshFrame, receivedAt: number): boolean;
  latest(): MeshFrame | null;
  faceVisible(now: number): boolean;
  fps(): number;
  reset(): void;
}

/** Réception du maillage sur un canal non ordonné : seule la frame la plus récente compte. */
export function createMeshReceiver({ staleMs = 500 }: MeshReceiverOptions = {}): MeshReceiver {
  let last: MeshFrame | null = null;
  let lastAt = -Infinity;
  let stats = createFrameStats();
  return {
    push(frame, receivedAt) {
      if (last && frame.seq <= last.seq) return false;
      last = frame;
      lastAt = receivedAt;
      stats.record(receivedAt, 0);
      return true;
    },
    latest: () => last,
    faceVisible: (now) => !!last && last.points.length > 0 && now - lastAt <= staleMs,
    fps: () => stats.get().fps,
    reset() {
      last = null;
      lastAt = -Infinity;
      stats = createFrameStats();
    },
  };
}
